import type { EnvironmentTasksEntry, EnvironmentTasksParams } from "./types";

/**
 * Stable composite key for the per-environment task store.
 *
 * Keyed by `project/env` only — deliberately NOT the org. The card builds this
 * key from the route's org param, but the live activity stream resolves the org
 * from `orgByProjectId`; on an org-id URL the two disagree, so keying on the org
 * would file live updates under a key the card never reads and the row's status
 * would freeze until a reload. Project ids are globally unique, so `project/env`
 * is unique on its own (mirrors the `taskActivities` slice).
 */
export const getEnvironmentTasksKey = ({
  projectId,
  environmentId
}: EnvironmentTasksParams) => `${projectId}/${environmentId}`;

/** A fresh, mutable entry for reducers to populate. */
export const createEnvironmentTasksEntry = (): EnvironmentTasksEntry => ({
  definitions: [],
  activities: [],
  isLoading: false,
  hasLoaded: false,
  error: null,
  isNonRetryableError: false,
  runningByTask: {}
});
